module.exports = __webpack_public_path__ + "static/media/r-Real Numbers.ac07daa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/r-Real Numbers.png
// module id = 182
// module chunks = 0